"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const luxon = __importStar(require("luxon"));
function formatDateString(date, timezone) {
    if (typeof date === 'string') {
        date = new Date(date);
    }
    return luxon.DateTime.fromJSDate(date, { zone: timezone })
        .startOf('second')
        .toISO({ suppressMilliseconds: true });
}
exports.formatDateString = formatDateString;
//# sourceMappingURL=format-date.js.map